// @ts-nocheck
import { writable } from 'svelte/store';

export const analyticsStore = writable({
  logEvent: () => {}
});
